module.exports = __webpack_public_path__ + "img/admission-1.5f388241.jpg";